import { JSXElement, lazy } from 'solid-js';
import { getSlug, HostedAuthPaths } from '~/components/AppRouter/utils.ts';
import { Route } from '@solidjs/router';
import { withHostedAuthState } from '~/pages/ExternalPages/commons/contexts/HostedAuthStateValidator.tsx';

const Login = lazy(() => import('~/pages/ExternalPages/Login'));
const Signup = lazy(() => import('~/pages/ExternalPages/Signup'));
const OrganizationSwitcher = lazy(
  () => import('~/pages/ExternalPages/OrganizationSwitcher')
);
const GenericHostedAuthError = lazy(
  () => import('~/pages/ExternalPages/commons/Errors/GenericHostedAuthError')
);
const OauthConsent = lazy(() => import('~/pages/ExternalPages/OauthConsent'));
const AdminPortalPreview = lazy(
  () =>
    import('~/pages/Customizations/CustomizationPreviews/AdminPortalPreview')
);
const ConfirmLogout = lazy(() => import('~/pages/ExternalPages/ConfirmLogout'));

const LogoutSuccess = lazy(() => import('~/pages/ExternalPages/LogoutSuccess'));

export default function HostedAppRoutes(): JSXElement {
  return (
    <Route path={getSlug.getHostedAuthPagesBaseNamespace()}>
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.LOGIN)}
        component={withHostedAuthState(Login)}
      />
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.LOGIN_PREVIEW)}
        component={Login}
      />
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.ADMIN_PORTAL_PREVIEW)}
        component={AdminPortalPreview}
      />
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.SIGNUP)}
        component={withHostedAuthState(Signup)}
      />
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.ORG_SWITCHER)}
        component={withHostedAuthState(OrganizationSwitcher)}
      />
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.GENERIC_ERROR)}
        component={GenericHostedAuthError}
      />
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.GENERIC_ERROR_ALIAS)}
        component={GenericHostedAuthError}
      />
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.OAUTH_CONSENT)}
        component={OauthConsent}
      />
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.CONFIRM_LOGOUT)}
        component={ConfirmLogout}
      />
      <Route
        path={getSlug.hostedAuthPages(HostedAuthPaths.LOGOUT_SUCCESS)}
        component={LogoutSuccess}
      />
    </Route>
  );
}
